<template>
  <div class="player">
    <div class="player_header">
      <cl-svg-icon
        width="20"
        height="20"
        icon-class="page_back_white"
        class="mr4"
        @click.native="backPage"
      ></cl-svg-icon>
      <span @click="backPage"> {{ title }}</span>
    </div>
    <div class="player_main">
      <div class="player_list">
        <div class="list_tabs">
          <div
            class="tabs_item"
            v-for="item in positions"
            :key="item.key"
            @click="clickTab(item)"
            :class="{ 'is-active': tab === item.key }"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="players" v-if="playerList.length">
          <div
            class="player_item"
            v-for="item in playerList"
            :key="item.id"
            @click="clickPlayer(item)"
          >
            <cl-avatar
              width="98"
              height="98"
              class="mr15"
              :src="item.avatar"
              radius="0"
            ></cl-avatar>
            <div>
              <div class="name">{{ item.name }}</div>
              <div class="date">{{ item.birthday }}</div>
            </div>
          </div>
        </div>
        <cl-no-data v-else height="calc(100% - 54px)"></cl-no-data>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      positions: [
        {
          name: "前锋",
          key: "forward",
        },
        {
          name: "中场",
          key: "midfielder",
        },
        {
          name: "后卫",
          key: "defender",
        },
        {
          name: "守门员",
          key: "goalkeeper",
        },
      ],
      tab: sessionStorage.getItem("tabs") || "forward",
      playerList: [],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    titleInfo() {
      return this.$route.query || {};
    },
    title({ titleInfo }) {
      let res = `${titleInfo.year}年龄段球员 -
        ${titleInfo.type === "man" ? "男子" : "女子"}`;
      return res;
    },
  },
  methods: {
    backPage() {
      sessionStorage.setItem("tabs", "forward");
      this.$router.push(
        this.$sg.ss.get("dataType") && this.$sg.ss.get("dataType") == "woman"
          ? "/home-woman"
          : "/home"
      );
    },
    clickTab(item) {
      if (this.tab === item.key) return;
      sessionStorage.setItem("tabs", item.key);
      this.tab = item.key;
      this.getData();
    },
    clickPlayer(item) {
      console.log(item);
      this.$router.push(
        "/player/details?id=" + item.id + "&tenant_id=" + item.tenant_id
      );
    },
    getData() {
      const { type, year = "2014", formPath } = this.titleInfo;
      let params = {
        position: this.tab,
        year,
      };
      formPath === "home-woman"
        ? this.getWoamnPlayers(params)
        : this.getPlayers(params, type);
    },
    // 所有球员
    getPlayers(params, type) {
      params.sex = type === "man" ? 1 : 2;
      this.$server.getPlayerList(params).then((res) => {
        this.playerList = res.data;
      });
    },
    // 女子球员
    getWoamnPlayers(params) {
      this.$server.getWomanPlayerList(params).then((res) => {
        this.playerList = res.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.player {
  width: 100%;
  height: 100%;
}
.player_header {
  width: 100%;
  height: 115px;
  padding: 12px 24px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
  background-image: url("~@/assets/images/cfa/header_bg.png");
  > span {
    cursor: pointer;
  }
}
.player_main {
  width: 100%;
  height: calc(100% - 115px);
  padding: 0 24px;
  box-sizing: border-box;
}
.player_list {
  position: relative;
  top: -54px;
  background-color: #fff;
  width: 100%;
  height: calc(100% + 30px);
  border-radius: 4px;
  padding: 0 24px;
  box-sizing: border-box;
}
.list_tabs {
  display: flex;
  width: 100%;
  height: 54px;
  padding: 8px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e9edf3;
  .tabs_item {
    width: 68px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    color: #81818a;
    font-size: 14px;
    cursor: pointer;
    border-radius: 2px;
  }
  .is-active {
    background: #326a54;
    color: #fff;
  }
}
.players {
  width: calc(100% + 16px);
  height: calc(100% - 54px);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: auto;
  padding-bottom: 24px;
  box-sizing: border-box;
  .player_item {
    width: 213px;
    height: 98px;
    margin-right: 16px;
    margin-top: 16px;
    background: #326a540f;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .name {
    font-size: 18px;
    margin-bottom: 4px;
    color: #000000;
  }
  .date {
    font-size: 14px;
    font-family: DINRegular;
    opacity: 0.6;
    color: #000000;
  }
}
</style>
